import { useAppSelector } from 'hooks/reduxHooks'
import getLuxPlusPrimaryCashPrice from 'luxPlus/lib/getLuxPlusPrimaryCashPrice'
import { isGoogleHotelAdsBot } from 'selectors/accountSelectors'
import { isGhaPriceDisplay } from 'selectors/routerSelectors'
import useLuxPlusDisplayedMode from './useLuxPlusDisplayedMode'

interface Options {
  price: number
  memberPrice: number
  offerConfig?: App.OfferLuxPlusConfig
}

/**
 * Returns the cash amount rendered as primary by LuxPlusPriceStack.
 */
export default function useLuxPlusPrimaryCashPrice({
  price,
  memberPrice,
  offerConfig,
}: Options): number {
  const displayedMode = useLuxPlusDisplayedMode({ price, memberPrice, offerConfig })
  const isGoogleHotelAds = useAppSelector(isGoogleHotelAdsBot)
  const isGhaPricing = useAppSelector(isGhaPriceDisplay)

  return getLuxPlusPrimaryCashPrice(
    price,
    memberPrice,
    displayedMode,
    isGoogleHotelAds,
    isGhaPricing,
  )
}
